import { Participant } from "@/reducers/chatsSlice"
import { useAppSelector } from "@/reducers/hooks"
import {
  selectActiveChat,
  selectDriverParticipant,
} from "@/reducers/chatsSliceSelectors"

function useActiveChatDriver(): Participant | undefined {
  const activeChat = useAppSelector(selectActiveChat)
  return useAppSelector(selectDriverParticipant(activeChat.jid))
}

export default useActiveChatDriver
